// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2ClientGetAllClientsGetAllClientsResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2ClientGetAllClientsGetAllClientsResponse.attributeTypeMap;
    }
}
AuthenticationV2ClientGetAllClientsGetAllClientsResponse.discriminator = undefined;
AuthenticationV2ClientGetAllClientsGetAllClientsResponse.additionalProperties = false;
AuthenticationV2ClientGetAllClientsGetAllClientsResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=authenticationV2ClientGetAllClientsGetAllClientsResponse.js.map